import React from 'react';
import { Form } from 'react-bootstrap';
import { Fields, IFilter } from 'utils/filtros';
import { useDispatch } from 'react-redux';
import { vagasActions } from 'store/ducks';

// eslint-disable-next-line react/prop-types
const FilterItem = ({ label, data, field }) => {
  const dispatch = useDispatch();

  const handleChange = e => {
    const { value } = e.target;

    if (value === '---') {
      return dispatch(vagasActions.listarVagas());
    }

    switch (field) {
      case Fields.areasDeAtuacao:
        dispatch(vagasActions.filtarVagas(IFilter.in(field, value)));
        break;
      case Fields.nivelDeEscolaridade:
        dispatch(vagasActions.filtarVagas(IFilter.in(field, value)));
        break;
      case Fields.regimeDeContratacao:
        dispatch(vagasActions.filtarVagas(IFilter.in(field, value)));
        break;
      default:
        break;
    }
    return null;
  };

  return (
    <Form.Group controlId="filtrar">
      <Form.Label>{label}</Form.Label>
      {data && (
        <Form.Control as="select" name={field} onChange={handleChange}>
          <option>---</option>
          {Object.entries(data).map(([key, value]) => {
            return (
              <option key={key} value={key}>
                {value}
              </option>
            );
          })}
        </Form.Control>
      )}
    </Form.Group>
  );
};

export default FilterItem;
